import React from "react";
// Components
import StopWatch from "./StopWatch";
import SessionHistory from "./SessionHistory";
import WorkOnTaskBox from "./WorkOnTaskBox";

// Variables
import { StatusTypes } from "../../variables";

const WorkOn = ({ activeTask, onFinishSession }) => {
  return (
    <div className="h-full flex flex-col">
      {/* Label + Add button */}
      <div className="relative flex grow-0 justify-between align-center my-4">
        <h1 className="text-4xl">Work on</h1>
      </div>
      <div className="w-72 ">
        {/* Work on task*/}
        <WorkOnTaskBox activeTask={activeTask} />
        {/* StopWatch */}
        {activeTask && activeTask._Status !== StatusTypes.COMPLETED && (
          <StopWatch onFinishSession={onFinishSession}/>
        )}
        {activeTask && <SessionHistory sessions={activeTask._Sessions}/>}
      </div>
    </div>
  );
};

export default WorkOn;
